package com.exura.components.layouts.plan

import androidx.compose.runtime.Composable
import com.exura.components.layouts.NavigableLayoutScope
import com.exura.features.plandefinition.domain.builder.plan.BasePlanBuilderNew
import com.exura.features.plandefinition.domain.model.element.BasePlanElement
import com.exura.features.plandefinition.domain.model.plan.BasePlan

class PlanConstructorLayoutScope(
    val navScope: NavigableLayoutScope,
    val planBuilder: BasePlanBuilderNew<out BasePlan>,
    val layoutMode: LayoutMode,
    val viewMode: ViewMode,
    val sideBarElements: List<SideBarPlanElement>,
    private val controller: PlanConstructorLayoutController,
) {
    fun setInternalNavigationStrategy(strategy: (suspend (SideBarPlanElement) -> Unit)?) =
        controller.setSideBarNavigationStrategy(strategy)

    fun setTooltipRenderStrategy(strategy: @Composable (BasePlanElement, Int) -> Unit) =
        controller.setTooltipContentRenderStrategy(strategy)

    fun markSelection(
        seriesPos: Int?,
        collectionPos: Int?
    ) = controller.markSelection(seriesPos, collectionPos)

    fun refreshSideBar() = controller.refreshSideBarItems()
}
